import React, { useState } from 'react';
import { useCountdown } from './useCountdown';
import { trackMetaPixel } from './metaPixel';
const CHECKOUT_URLS = {
  base: 'https://checkout.tusbeneficios.shop/cart/51484189589737:1',
  pro: 'https://checkout.tusbeneficios.shop/cart/51484189655273:1'
} as const;
export function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'pro'>('pro');
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(24);
  const handleCheckout = () => {
    trackMetaPixel('InitiateCheckout', {
      content_name: selectedPlan === 'pro' ? 'Guitarra Fácil PRO' : 'Guitarra Fácil'
    });
    window.location.href = CHECKOUT_URLS[selectedPlan];
  };
  return <section id="pricing" className="w-full bg-fondo-principal text-white py-section px-4" data-id="element-107">
      <div className="text-center mb-10" data-id="element-108">
        <p className="text-sm font-bold text-dorado-detalles mb-3 tracking-widest uppercase" data-id="element-109">
          🕐 Esta oferta termina en
        </p>
        <div className="flex justify-center gap-3" data-id="element-110">
          <div className="flex flex-col items-center" data-id="element-111">
            <div className="bg-timer-box w-16 h-16 rounded-lg flex items-center justify-center text-3xl font-bold border border-white/10 shadow-inner" data-id="element-112">
              {hours}
            </div>
            <span className="text-[10px] text-gray-400 mt-2 font-bold" data-id="element-113">
              HORAS
            </span>
          </div>
          <div className="text-3xl font-bold text-gray-500 mt-3" data-id="element-114">:</div>
          <div className="flex flex-col items-center" data-id="element-115">
            <div className="bg-timer-box w-16 h-16 rounded-lg flex items-center justify-center text-3xl font-bold border border-white/10 shadow-inner" data-id="element-116">
              {minutes}
            </div>
            <span className="text-[10px] text-gray-400 mt-2 font-bold" data-id="element-117">
              MIN
            </span>
          </div>
          <div className="text-3xl font-bold text-gray-500 mt-3" data-id="element-118">:</div>
          <div className="flex flex-col items-center" data-id="element-119">
            <div className="bg-timer-box w-16 h-16 rounded-lg flex items-center justify-center text-3xl font-bold border border-white/10 shadow-inner" data-id="element-120">
              {seconds}
            </div>
            <span className="text-[10px] text-gray-400 mt-2 font-bold" data-id="element-121">
              SEG
            </span>
          </div>
        </div>
      </div>

      <div className="text-center mb-8" data-id="element-122">
        <h2 className="text-3xl font-bold mb-2" data-id="element-123">ELEGÍ TU GUITARRA FÁCIL PRO</h2>
        <p className="text-dorado-detalles text-sm font-medium" data-id="element-124">
          Ambas opciones incluyen los 6 tomos + 4 bonos completos
        </p>
      </div>

      <div className="flex flex-col gap-4 mb-8" data-id="element-125">
        {/* Plan Base */}
        <div onClick={() => setSelectedPlan('base')} className={`relative p-5 rounded-2xl border-2 cursor-pointer transition-all ${selectedPlan === 'base' ? 'border-botones-acentos bg-[#24180d]' : 'border-white/10 bg-[#1A1108] hover:bg-[#24180d]'}`} data-id="element-126">
          <div className="flex items-start gap-4" data-id="element-127">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 mt-1 ${selectedPlan === 'base' ? 'border-botones-acentos' : 'border-gray-500'}`} data-id="element-128">
              {selectedPlan === 'base' && <div className="w-3 h-3 rounded-full bg-botones-acentos" data-id="element-129" />}
            </div>
            <div className="flex-1" data-id="element-130">
              <h3 className="font-bold text-lg mb-1" data-id="element-131">🎸 GUITARRA FÁCIL</h3>
              <p className="text-sm text-gray-400 mb-3" data-id="element-132">
                6 tomos + 4 bonos esenciales
              </p>
              <div className="flex items-center gap-2" data-id="element-133">
                <span className="text-gray-500 line-through text-sm" data-id="element-134">
                  $34.900
                </span>
                <span className="text-2xl font-bold" data-id="element-135">18.990</span>
              </div>
            </div>
          </div>
        </div>

        {/* Plan PRO */}
        <div onClick={() => setSelectedPlan('pro')} className={`relative p-5 rounded-2xl border-2 cursor-pointer transition-all ${selectedPlan === 'pro' ? 'border-botones-acentos bg-[#24180d]' : 'border-white/10 bg-[#1A1108] hover:bg-[#24180d]'}`} data-id="element-136">
          <div className="absolute -top-3 right-4 bg-badges-dorado text-fondo-principal text-[10px] font-bold px-2 py-1 rounded-full" data-id="element-137">
            ⭐ MÁS ELEGIDO
          </div>
          <div className="flex items-start gap-4" data-id="element-138">
            <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center shrink-0 mt-1 ${selectedPlan === 'pro' ? 'border-botones-acentos' : 'border-gray-500'}`} data-id="element-139">
              {selectedPlan === 'pro' && <div className="w-3 h-3 rounded-full bg-botones-acentos" data-id="element-140" />}
            </div>
            <div className="flex-1" data-id="element-141">
              <h3 className="font-bold text-lg mb-1" data-id="element-142">🚀 GUITARRA FÁCIL PRO</h3>
              <p className="text-sm text-gray-400 mb-2" data-id="element-143">
                6 tomos + 4 bonos + 3 bonos adicionales
              </p>
              <div className="inline-block bg-green-600 text-white text-[10px] font-bold px-2 py-1 rounded mb-3" data-id="element-144">
                AHORRÁS $34.910
              </div>
              <div className="flex items-center gap-2" data-id="element-145">
                <span className="text-gray-500 line-through text-sm" data-id="element-146">
                  $54.900
                </span>
                <span className="text-2xl font-bold text-botones-acentos" data-id="element-147">
                  $27.990
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button onClick={handleCheckout} className="w-full h-[56px] bg-botones-acentos hover:bg-orange-500 text-white font-bold rounded-xl text-lg transition-colors flex items-center justify-center gap-2 mb-3" data-id="element-148">
        {selectedPlan === 'pro' ? 'SÍ, QUIERO GUITARRA FÁCIL PRO →' : 'SÍ, QUIERO GUITARRA FÁCIL →'}
      </button>

      <p className="text-center text-xs text-gray-400 mb-6" data-id="element-149">
        La opción más elegida por quienes quieren tocar de verdad, no solo
        empezar
      </p>

      <div className="flex justify-center items-center gap-4 text-xs text-gray-400" data-id="element-150">
        <span className="flex items-center gap-1" data-id="element-151">🔒 Pago seguro</span>
        <span data-id="element-152">·</span>
        <span className="flex items-center gap-1" data-id="element-153">⚡ Acceso inmediato</span>
        <span data-id="element-154">·</span>
        <span className="flex items-center gap-1" data-id="element-155">🛡️ Garantía 7 días</span>
      </div>
    </section>;
}